
import { useEffect } from 'react'

/* Styles */
import style from './SchoolRecordForm.module.css'

/* Apis */
import { adminGetSchoolRecordVer2Api, adminSaveSchoolRecordVer2Api } from '../../../api/admin/schoolRecord'

/* Libraries */
import { useForm } from 'react-hook-form'

/* Utils */
import { swalAlert, swalErrorAlert } from '../../../utils/swal/swal'
import { schoolRecord_ver2_default_value } from '../../../utils/data/common'

/* Components */
import StudentInformationTable from './write/StudentInformationTable'
import AcademicRecordTable from './write/AcademicRecordTable'
import GradingScale from './write/GradingScale'
import TeacherCommentsTable from './write/TeacherCommentsTable'
import EducationalBackgroundTable from './write/EducationalBackgroundTable'
import AttendanceRecordTable from './write/AttendanceRecordTable'
import AwardsTable from './write/AwardsTable'
import ExtracurricularTable from './write/ExtracurricularTable'
import ExploratoryTable from './write/ExploratoryTable'
import VolunteerTable from './write/VolunteerTable'
import BehavioralRemarkTable from './write/BehavioralRemarkTable'
import AdditionalComments from './write/AdditionalComments'
import TeacherCommentsSignBox from './write/TeacherCommentsSignBox'


const SchoolRecordWriteForm = ({ userId, schoolRecordId = '' }) => {
    /* Use React Form */
    const { register, handleSubmit, reset, control } = useForm({
        defaultValues: schoolRecord_ver2_default_value
    })

    useEffect(() => {
        const getSchoolRecordData = async (schoolRecordId) => {
            try {
                const result = await adminGetSchoolRecordVer2Api(schoolRecordId)

                if (result.status === 200) {
                    const formData = result.data?.resData
                    reset(formData)
                }
                else {
                    reset(schoolRecord_ver2_default_value)
                }

            } catch (error) {
                console.error(error);
                swalErrorAlert('생활기록부 조회 에러', '생활기록부 데이터를 불러오는중 에러가 발생하였습니다.')
            }
        }

        if (schoolRecordId) {
            getSchoolRecordData(schoolRecordId)
        }

    }, [schoolRecordId])


    /* onSubmit */
    const onSubmit = async (data) => {

        // Validation
        if (!userId) return false

        if (!data?.title.trim()) {
            swalAlert('', '제목을 입력해주세요.', '', '확인')
            return false
        }

        // Api
        try {
            let jsonData = {}
            Object.keys(data).forEach((key) => {
                if (key !== 'fileUpload') jsonData[key] = data[key]
            })

            const formData = new FormData();
            formData.append("userId", JSON.stringify(userId))
            formData.append("jsonData", JSON.stringify(jsonData))
            if (schoolRecordId) {
                formData.append("schoolRecordId", JSON.stringify(schoolRecordId))
            }

            const response = await adminSaveSchoolRecordVer2Api(formData)

            if (response.data.code === 201 || response.data.code === 200) {
                reset()
                swalAlert("저장 완료", "성공적으로 저장되었습니다.", "success", "확인", () => window.location.reload(true))
            }

        } catch (error) {
            console.error(error);
            swalErrorAlert('생활기록부 저장 에러', '생활기록부를 저장하는 도중에 에러가 발생하였습니다.')

        }
    }


    return (
        <form id='schoolRecordForm' onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
                <label htmlFor="title" className="form-label">제목</label>
                <input type="text" id="title" className="form-control"
                    {...register('title')}
                    placeholder="제목을 입력해주세요"
                    maxLength={50}
                    required
                />
            </div>
            <hr className='divider-row' />

            <div className='py-3'>
                <label className="form-label pb-3">생활기록부</label>
                <div className={style.schoolRecordWrap}>
                    <div className={style.schoolRecord}>
                        <div className={style.topTitleWrap}>
                            <h1 className={style.topTitle}>Certificate of School Record</h1>
                        </div>

                        {/* 1. Student Information */}
                        <div className={`${style.section} student-info`}>
                            <h2 className={style.sectionTitle}>1. Student Information</h2>

                            <div className={style.sectionContent}>
                                <StudentInformationTable register={register} />
                            </div>
                        </div>


                        {/* 2. Academic Record */}
                        <div className={`${style.section} academic-record`}>
                            <h2 className={style.sectionTitle}>2. Academic Record</h2>

                            <div className={style.sectionContent}>
                                <AcademicRecordTable register={register} />
                                <GradingScale />
                            </div>
                        </div>


                        {/* 3. Teacher’s comments on subjects (G10-1) */}
                        <div className={`${style.section} teacher-comments g10-1`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G10-1)</h2>

                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={10} semester={1} />

                                <TeacherCommentsSignBox isRead={false} />
                            </div>
                        </div>

                        {/* 3. Teacher’s comments on subjects (G10-2) */}
                        <div className={`${style.section} teacher-comments g10-2`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G10-2)</h2>

                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={10} semester={2} />
                                <TeacherCommentsSignBox isRead={false} />
                            </div>
                        </div>

                        {/* 3. Teacher’s comments on subjects (G11-1) */}
                        <div className={`${style.section} teacher-comments g11-1`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G11-1)</h2>

                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={11} semester={1} />
                                <TeacherCommentsSignBox isRead={false} />
                            </div>
                        </div>

                        {/* 3. Teacher’s comments on subjects (G11-2) */}
                        <div className={`${style.section} teacher-comments g11-2`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G11-2)</h2>

                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={11} semester={2} />
                                <TeacherCommentsSignBox isRead={false} />
                            </div>
                        </div>

                        {/* 3. Teacher’s comments on subjects (G12-1) */}
                        <div className={`${style.section} teacher-comments g12-1`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G12-1)</h2>

                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={12} semester={1} />
                                <TeacherCommentsSignBox isRead={false} />
                            </div>
                        </div>

                        {/* 3. Teacher’s comments on subjects (G12-2) */}
                        <div className={`${style.section} teacher-comments g12-2`}>
                            <h2 className={style.sectionTitle}>3. Teacher’s comments on subjects (G12-2)</h2>

                            <div className={style.sectionContent}>
                                <TeacherCommentsTable register={register} control={control} grade={12} semester={2} />
                                <TeacherCommentsSignBox isRead={false} />
                            </div>
                        </div>


                        {/* 4. Educational Background */}
                        <div className={`${style.section} educational-background`}>
                            <h2 className={style.sectionTitle}>4. Educational Background</h2>

                            <div className={style.sectionContent}>
                                <EducationalBackgroundTable register={register} />
                            </div>
                        </div>


                        {/* 5. Attendance Record */}
                        <div className={`${style.section} attendance`}>
                            <h2 className={style.sectionTitle}>5. Attendance Record</h2>

                            <div className={style.sectionContent}>
                                <AttendanceRecordTable register={register} />
                            </div>
                        </div>


                        {/* 6. Awards & Certificate of Appointment  */}
                        <div className={`${style.section} awards`}>
                            <h2 className={style.sectionTitle}>6. Awards & Certificate of Appointment</h2>

                            <h2 className={style.sectionTitle}>6-1. &lt;in school&gt; Awards</h2>
                            <div className={style.sectionContent}>
                                <AwardsTable register={register} control={control} name={`awards.inSchool`} type={'awards'} />
                            </div>

                            <h2 className={style.sectionTitle}>6-2. &lt;out of school&gt; Awards</h2>
                            <div className={style.sectionContent}>
                                <AwardsTable register={register} control={control} name={`awards.outSchool`} type={'awards'} />
                            </div>

                            <h2 className={style.sectionTitle}>6-3. Certificate of Appointment</h2>
                            <div className={style.sectionContent}>
                                <AwardsTable register={register} control={control} name={`awards.certificate`} type={'certificate'} />
                            </div>
                        </div>


                        {/* 7. Extracurricular Activities */}
                        <div className={`${style.section} extracurricular`}>
                            <h2 className={style.sectionTitle}>7. Extracurricular Activities</h2>

                            <div className={style.sectionContent}>
                                <ExtracurricularTable register={register} control={control} />
                            </div>
                        </div>


                        {/* 8. Exploratory Activities */}
                        <div className={`${style.section} exploratory`}>
                            <h2 className={style.sectionTitle}>8. Exploratory Activities</h2>

                            <div className={style.sectionContent}>
                                <ExploratoryTable register={register} control={control} />
                            </div>
                        </div>


                        {/* 9. Volunteer work */}
                        <div className={`${style.section} volunteer`}>
                            <h2 className={style.sectionTitle}>9. Volunteer work</h2>

                            <div className={style.sectionContent}>
                                <VolunteerTable register={register} control={control} />
                            </div>
                        </div>


                        {/* 10. Behavioral Remark and Overall Evaluation */}
                        <div className={`${style.section} behavioral`}>
                            <h2 className={style.sectionTitle}>10. Behavioral Remark and Overall Evaluation</h2>

                            <div className={style.sectionContent}>
                                <BehavioralRemarkTable register={register} control={control} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <hr className='divider-row' />

            <div className='py-3'>
                <label className="form-label pb-3">선생님 의견</label>
                <AdditionalComments register={register} control={control} />
            </div>
        </form>
    )
}

export default SchoolRecordWriteForm